import {
  AddTeamMemberRequest,
  TeamMemberResponse,
  TeamMembersResponse
} from '../models/api';
import { deleteData, getData, postData, putData } from './api';
import { ApiEmptyResponse, ResponseData } from './models';

export const list = async (
  teamReference: string
): Promise<ResponseData<TeamMembersResponse>> =>
  getData(`api/teams/${teamReference}/members`);

export const add = async (
  teamReference: string,
  model: AddTeamMemberRequest
): Promise<ResponseData<TeamMemberResponse>> =>
  postData<TeamMemberResponse>(`api/teams/${teamReference}/members`, model);
export const update = async (
  teamReference: string,
  teamMemberReference: string,
  model: AddTeamMemberRequest
): Promise<ResponseData<TeamMemberResponse>> =>
  putData<TeamMemberResponse>(
    `api/teams/${teamReference}/members/${teamMemberReference}`,
    model
  );
export const remove = async (
  teamReference: string,
  teamMemberReference: string
): Promise<ResponseData<ApiEmptyResponse>> =>
  deleteData(`api/teams/${teamReference}/members/${teamMemberReference}`);
